import request from '@/utils/request'

// 取得行為種類列表 [Get]
export function getActionType(data) {
  return request({
    url: '/Log/getActionType',
    method: 'get',
  })
}

// 查詢行為紀錄LOG [Post]
export function getHistoryLogs(data) {
  return request({
    url: '/Log/getHistoryLogs',
    method: 'post',
    data,
  })
}

// 輸出行為紀錄LOG的EXCEL [Post]
export function exportHistoryLogsExcel(data) {
  return request({
    url: '/Log/exportHistoryLogsExcel',
    method: 'post',
    data,
  })
}

// 取得行為統計數據 [Post]
export function getLogStatistical(data) {
  return request({
    url: '/Log/GetLogStatistical',
    method: 'post',
    data,
  })
}
